export const requiredFieldsForEntity = [
  'name_of_entity',
  'entity_type_id',
  'hierarchy_in_group_id',
  'parent_lei',
  'lei_entity_making_use_ICT_service',
  'lei_entity_signing_contractual_arrangement',
  'nature_id',
  'integration_date',
  'deletion_date',
  'total_assets',
  'competent_authority_id',
  'country_id',
  'date_of_last_update',
  'financial_entity_lei_id',
  'reporting_date',
  'start_date',
  'currency_id',
  'lei_of_entity',
];

export const requiredFieldsForBranch = [
  'head_office_lei',
  'branch_name',
  'branch_identification_code',
  'entity_id',
  'country_id',
  'start_date',
];

export const requiredFieldsForFunction = [
  'function_identifier',
  'function_name',
  'criticality_assessment_id',
  'reasons_for_criticality',
  'date_of_last_assessment',
  'recovery_time_objective',
  'recovery_point_objective',
  'impact_of_discontinuing_id',
  'licensed_activity_id',
  'entity_id',
  'function_level_id',
  'start_date',
];

export const requiredFieldsForTPP = [
  'ict_service_provider_identification_code',
  'notice_period',
  'identification_code_type',
  'tpp_code_type_id',
  'substitutability',
  'non_subst_reason_id',
  'third_party_service_provider_name',
  'person_type_id',
  'headquarters_country',
  'iso_code',
  'entity_nature',
  'ultimate_parent_identification_code',
  'ultimate_parent_identification_code_type',
  'add_ict_service_provider_identification_code',
  'add_identification_code_type',
  'third_party_service_provider_legal_name',
  'last_audit_date',
  'alternative_providers_identified_id',
  'alternative_providers_identified_name',
  'exit_plan_exists_id',
  'exit_plan_exists_name',
  'possibility_of_reintegration_id',
  'possibility_of_reintegration_name',
  'rank',
  'recipient_identification_code',
  'recipient_identification_type',
  'substitutability_of_ict_provider_name',
  'substitutability_of_ict_provider_id',
  'start_date',
];

export const requiredFieldsForCurrencyAndCosts = [
  'currency_id',
  'total_annual_expense',
  'start_date',
];

export const requiredFieldsForICTServices = [
  'ictService_contractual_arrangement_id',
  'ictService_start_date',
  'ictService_contractual_arrangement_reference_number',
  'ict_system_ids',
  'alternative_ict_tpp_identification',
  'contractual_arrangement_id',
  'local_regulator_criticality_id',
  'ict_services_criticality_id',
  'possibility_of_reintegration_id',
  'exit_plan_exists_id',
  'start_date',
  'criticality_assessment_id',
  'level_of_reliance_id',
  'alternatives_exit_id',
  'impact_of_discontinuing_ict_services_id',
  'ict_service_level_id',
  'country_id',
  'function_id',
  'storage_of_data_id',
  'ict_service_type_id',
  'country_id',
  'local_regulator_criticality_id',
  'ictService_description',
];

export const requiredFieldsForContractualArrangement = [
  'arrangement_reference_number',
  'start_date',
  'terminat_reason_id',
  'contract_type_arrangement_id',
  'overarching_reference_number',
  'linked_contractual_arrangement',
  'notice_period',
  'governing_law_country_id',
  'entity_id',
  'third_party_service_provider_id',
  'contract_name',
];

export const requiredFieldsForData = [
  'location_of_data_at_rest',
  'location_of_data_management',
  'start_date',
  'sensitiveness_of_data_stored_by_ict_tpsp_id',
];

export const requiredFieldsForICTSystems = ['name', 'start_date'];
